export default {"src":"/_next/static/media/close-icon-yellow.142dfc41.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};